import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import PipelineFunnel from "./components/PipelineFunnel";
import Reminder from "./components/Reminder";
import SectorFunnel from "./components/SectorFunnel";
import IndiaVsInternationalPie from "./components/IndiaVsInternationalPie";
import LatestActivity from "./components/LatestActivity";
import Opportunities from "./components/Opportunities";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import toastr from "../../utils/toast";
function LeadDashboard() {
  const navigate = useNavigate();
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [pipelineStatus, setPipelineStatus] = useState([]);
  const [bdRegion, setBdRegion] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [totalProspect, setTotalProspect] = useState(0);
  const [active_pipeline, setActivePipeline] = useState(0);
  const [verbal_commit, setVerbalCommit] = useState(0);
  const [Reminders, setReminders] = useState([]);
  const [Activities, setActivities] = useState([]);
  const [converted, setConverted] = useState(0);
  const [ProspectCandidates, setProspectCandidates] = useState([]);
  const statusRef = useRef();
  const user = JSON.parse(localStorage.getItem("user"));

  const pipeline_companies_status = async () => {
    try {
      setGlobalLoading(true);
      const res = await axios.get(
        `${API_BASE_URL}/companyinfo/pipeline_companies_status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res.data) {
        setPipelineStatus(res.data.pipeline_status);
        setBdRegion(res.data.bd_region);
        setIndustries(res.data.industries);
        setReminders(res.data.reminders);
        setActivities(res.data.activities);
        setProspectCandidates(res.data.prospect_candidates);
      }
    } catch (error) {
      setGlobalLoading(false);
      toastr.error(error.response.data.message);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    pipeline_companies_status();
  }, [token]);

  useEffect(() => {
    if (
      pipelineStatus.length <= 0 &&
      bdRegion.length <= 0 &&
      industries.length <= 0
    ) {
      return;
    }

    const { totalProspect, active_pipeline, verbal_commit, converted } =
      pipelineStatus.reduce(
        (sum, item) => {
          sum.totalProspect += item.total || 0;

          if ([2, 3, 4, 5, 6, 7].includes(item.id)) {
            sum.active_pipeline += item.total || 0;
          }

          if (item.id === 7) {
            sum.verbal_commit += item.total || 0;
          }

          if (item.id === 8) {
            sum.converted += item.total || 0;
          }

          return sum;
        },
        {
          totalProspect: 0,
          active_pipeline: 0,
          verbal_commit: 0,
          converted: 0,
        },
      );

    setTotalProspect(totalProspect);
    setActivePipeline(active_pipeline);
    setVerbalCommit(verbal_commit);
    setConverted(converted);
    console.log(
      "check----------",
      totalProspect,
      active_pipeline,
      verbal_commit,
      converted,
    );
    if (
      totalProspect === 0 &&
      active_pipeline === 0 &&
      verbal_commit === 0 &&
      converted === 0
    ) {
      navigate("/lead_dashboard/pipeline");
    }
  }, [pipelineStatus, bdRegion, industries]);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Lead Dashboard</h2>
          </div>
          <div className="my-auto mb-2">
            {(user.admin === "1" ||
              [609, 11, 12, 14].includes(Number(user.id))) && (
              <button
                onClick={() => navigate("/lead_dashboard/adminView")}
                className="btn btn-outline-secondary rounded-pill me-2"
              >
                Admin View
                <i className="fa-solid fa-arrow-right ms-2"></i>
              </button>
            )}
            <button
              onClick={() => navigate("/lead_dashboard/searchUniverse")}
              className="btn btn-outline-secondary rounded-pill me-2"
            >
              Target Universe
              <i className="fa-solid fa-arrow-right ms-2"></i>
            </button>
            <button
              onClick={() =>
                navigate("/lead_dashboard/pipeline")
              }
              className="btn btn-outline-secondary rounded-pill"
            >
              View BD Pipeline
              <i className="fa-solid fa-arrow-right ms-2"></i>
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill" style={{ cursor: "pointer" }}>
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between flex-row-reverse">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10 d-flex align-items-center justify-content-center">
                      <i className="fa-solid fa-building text-info text-opacity-25 fs-40"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Total Prospects
                    </p>
                    <h4 className="counter">
                      <CountUp start={0} end={totalProspect} duration={5} />
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill" style={{ cursor: "pointer" }}>
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between flex-row-reverse">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10  d-flex align-items-center justify-content-center">
                      <i className="fa-solid fa-arrow-trend-up text-primary text-opacity-25 fs-40"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Active Pipeline
                    </p>
                    <h4 className="counter">
                      <CountUp start={0} end={active_pipeline} duration={5} />
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill" style={{ cursor: "pointer" }}>
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between flex-row-reverse">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10  d-flex align-items-center justify-content-center">
                      <i className="fa-solid fa-users text-success text-opacity-25 fs-40"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Verbal Commits
                    </p>
                    <h4 className="counter">
                      <CountUp start={0} end={verbal_commit} duration={3} />
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div className="card flex-fill" style={{ cursor: "pointer" }}>
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between flex-row-reverse">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10  d-flex align-items-center justify-content-center">
                      <i className="fa-solid fa-arrow-trend-up text-success text-opacity-25 fs-40"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Converted
                    </p>
                    <h4 className="counter">
                      <CountUp start={0} end={converted} duration={3} />
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-8">
                    <div className="card">
                      <div className="card-body">
                        <h3 className="card-title">Pipeline Funnel</h3>
                        <PipelineFunnel chart_data={pipelineStatus} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card" style={{ minHeight: "26pc" }}>
                      <div className="card-body">
                        <h3 className="card-title">
                          <i className="fa-solid fa-bell text-warning text-opacity-75"></i>{" "}
                          Reminders
                        </h3>
                        <Reminder data={Reminders} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-lg-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h3 className="card-title">Sector Funnel</h3>
                        <SectorFunnel chart_data={industries} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h3 className="card-title">
                          <i className="fa-solid fa-globe me-1"></i>India vs
                          International
                        </h3>
                        <IndiaVsInternationalPie chart_data={bdRegion} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-lg-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <h3 className="card-title">Latest Activity</h3>
                          <span className="fs-15 fw-bolder text-black">
                            Last Meeting Date
                          </span>
                        </div>
                        <LatestActivity data={Activities} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-lg-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <h3 className="card-title">
                          <i className="fa-solid fa-lightbulb me-1 text-primary"></i>{" "}
                          Opportunities
                        </h3>
                        <Opportunities data={ProspectCandidates} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadDashboard;
